package team.platforma.multiplatform_material_extension.util.forms

import androidx.compose.runtime.State

class FormProperties(
    val form: Forms,
    val key: String,
)